import { generateUUID } from '@wix/form-schema';
import React, { useCallback, useMemo, useState } from 'react';
import { EXPERIMENTS } from '../../constants/experiments';
import { useExperiments } from '../../contexts/experiments-context';
import { useAddressAutofill } from '../../fields/multiline-address/multiline-address/address-autofill-context';
import { useFieldAttributes } from '../../sdk/components';
import { FieldDescriptionWUT, FieldErrorWUT, FieldLabelWUT } from '../../sdk/components-wut';
import { AutocompleteWUT } from '../autocomplete';
import { createOption } from '../autocomplete/autocomplete-wut';
import { useJapanAutocomplete } from './use-japan-autocomplete';
const allowAllOptions = ()=>true;
const PostalCodeInputWUT = ({ id, target, label, hideLabel, placeholder, required, description, value, onChange, error, hasError = false, errorMessage, disabled, prefix, onBlur, onFocus, FieldLayout, requiredIndicatorType, requiredIndicatorPlacement })=>{
    const { labelId, inputId, errorId, descriptionId, ariaDescribedBy } = useFieldAttributes(id, error, description);
    const { isExperimentEnabled } = useExperiments();
    const useFloatingUI = isExperimentEnabled(EXPERIMENTS.FLOATING_MULTILINE_ADDRESS_DROPDOWNS);
    const { onAddressSelect } = useAddressAutofill();
    const [isAutocompleteEnabled, setIsAutocompleteEnabled] = useState(false);
    const { searchByPostalCode } = useJapanAutocomplete({
        isAutocompleteEnabled
    });
    const [prediction, setPrediction] = useState();
    const options = useMemo(()=>prediction ? [
            createOption({
                id: generateUUID(),
                value: prediction.formattedAddress ?? undefined
            })
        ] : [], [
        prediction
    ]);
    const handleChange = useCallback(async (event)=>{
        const newValue = event.target.value;
        onChange(newValue);
        const address = await searchByPostalCode(newValue ?? '');
        setPrediction(address);
    }, [
        onChange,
        searchByPostalCode
    ]);
    const handleSelect = useCallback(async ()=>{
        setPrediction(undefined);
        if (prediction && onAddressSelect) {
            onAddressSelect(prediction);
        }
    }, [
        onAddressSelect,
        prediction
    ]);
    const handleManualInput = useCallback(()=>{
        setPrediction(undefined);
    }, []);
    const handleBlur = useCallback((event)=>{
        const newValue = event.target.value;
        setPrediction(undefined);
        onChange(newValue);
        onBlur?.();
    }, [
        onChange,
        onBlur
    ]);
    const handleFocus = useCallback(()=>{
        setIsAutocompleteEnabled(true);
        onFocus?.();
    }, [
        onFocus
    ]);
    return /*#__PURE__*/ React.createElement(FieldLayout, {
        fieldId: id,
        renderLabel: ()=>/*#__PURE__*/ React.createElement(FieldLabelWUT, {
                labelId: labelId,
                htmlFor: inputId,
                required: required,
                label: label,
                hideLabel: hideLabel,
                requiredIndicatorType: requiredIndicatorType,
                requiredIndicatorPlacement: requiredIndicatorPlacement
            }),
        renderInput: ()=>/*#__PURE__*/ React.createElement(AutocompleteWUT, {
                id: inputId,
                value: value,
                options: options,
                disabled: disabled,
                placeholder: placeholder,
                prefix: prefix,
                error: hasError,
                filterPredicate: allowAllOptions,
                onChange: handleChange,
                onSelect: handleSelect,
                onManualInput: handleManualInput,
                onBlur: handleBlur,
                onFocus: handleFocus,
                ariaDescribedBy: ariaDescribedBy,
                useFloatingUI: useFloatingUI,
                portalDataHook: `dropdown-portal-${target}`
            }),
        renderDescription: ()=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(FieldErrorWUT, {
                target: target,
                hasError: hasError,
                errorMessage: errorMessage,
                id: errorId
            }), /*#__PURE__*/ React.createElement(FieldDescriptionWUT, {
                description: description,
                id: descriptionId
            }))
    });
};
export default PostalCodeInputWUT;

//# sourceMappingURL=postal-code-input-wut.js.map